import classNames from 'classnames/bind';
import styles from './EntityInfo.module.scss';
import Card, { CardHeader } from '../../../components/Card';
import { EnrollmentType } from '../../../state/enrollment/enrollmentModel';
import EnrollmentSelector from './EnrollmentTypeField';
import SingleEnrollment from './SingleEnrollment';
import MultipleEnrollment from './MultipleEnrollment';

const cx = classNames.bind(styles);
const cardHeaderClasses = {
  wrapper: cx('entity-info__card-title-wrapper'),
  title: cx('entity-info__card-title'),
};

interface EntityInfoProps {
  enrollmentType: EnrollmentType;
}

const EntityInfo = (props: EntityInfoProps) => {
  const { enrollmentType } = props;

  return (
    <Card className={cx('entity-info__card')}>
      <CardHeader
        title="Enrollment and Administration"
        smallLogo
        classes={cardHeaderClasses}
      />
      <label className={cx('entity-info__label')}>ENROLLMENT TYPE</label>
      <EnrollmentSelector />
      {enrollmentType === EnrollmentType.SINGLE_ENTITY && <SingleEnrollment />}
      {enrollmentType === EnrollmentType.MULTIPLE_ENTITY && (
        <MultipleEnrollment />
      )}
    </Card>
  );
};

export default EntityInfo;
